import styled from 'styled-components';

import colors from 'styles/colors';

export const TextAreaComponentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  width: 100%;
`;

export const TextareaStyled = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 8px;
  border: 1px solid ${colors.gray_scale3};
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
  resize: none;
  box-sizing: border-box;
  overflow-y: auto;

  &:focus {
    outline: none;
    border-color: ${colors.brand_2};
  }
`;
